module.exports = __webpack_public_path__ + "static/favicon-96x96-3cd85bdfea68d62719262c74bfad37e4.png";